import React, { Component } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { GoDatabase } from 'react-icons/go';
import PreviewPane from 'blob_types/blobhub/dataset/nlp/preview/index';
import Config from "context/config";
import axios from 'axios';

function nlpPhaseLabel(revision) {
  if (!revision) return "Loading...";
  if (revision.phase === "draft") return "Draft";
  if (revision.phase === "commit") return "Commit";
  if (revision.phase === "snapshot") return "Snapshot";
  return "Loading...";
}

function nlpDefaultRoute({ orgId, blobId, forcedRevision, revision }) {
  if (forcedRevision && revision) {
    return `/${orgId}/${blobId}/revisions/${revision.id}`;
  }
  return `/${orgId}/${blobId}`;
}

export default class BlobShell extends Component {
  static settingsDisabled = true;

  static getTabs({ revision }) {
    return [
      {
        key: "default",
        title: nlpPhaseLabel(revision),
        icon: GoDatabase,
        isDefault: true,
        routeFor: nlpDefaultRoute,
      },
    ];
  }

  constructor(props) {
    super(props);

    this.state = {
      data: null,
      loading: true,
      notFound: false,
      details: {
        visible: false
      }
    };
  }

  /**
   * Data loading
   */

  loadRevisionData() {
    this.loadDatasetOverview();
  }

  loadDatasetOverview() {
    axios.get(`${Config.staticBaseUrl()}/revisions/${this.props.revision.id}/data.json`)
      .then( response => {
        this.setState({
          loading: false,
          data: response.data
        });
      }, error => {
        this.setState({ notFound: true });
      });
  }

  /**
   * UX
   */

  componentDidMount() {
    if ( this.props.revision ) {
      this.loadRevisionData();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.revision !== prevProps.revision) {
      this.loadRevisionData();
    }
  }

  render() {
    if ( this.state.notFound ) {
      return (
        <>
          <Container className="blob-header-row content-row">
            Failed to load revision data.
          </Container>
        </>
      );
    }

    if ( this.state.loading || null == this.state.data ) {
      return (
        <>
          <Container className="blob-header-row content-row">
            <Alert variant="primary">Loading revision data...</Alert>
          </Container>
        </>
      );
    }

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col sm={12}>
              <PreviewPane
                app={this.props.app}
                blob={this.props.blob}
                revision={this.props.revision}
                shell={this.state}
              />
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}
